$(document).ready(function ($) {

    "use strict";
    
    //Show checkout when custom fields are ready
    if($('.woocommerce-checkout').length) {
        $('.woocommerce-checkout').addClass('checkoutReady');
    }
    
    if($('.available-variations').length) {
        $('.available-variations').on('change', function() {
            const val = $(this).val(),
                $form = $(this).closest('.variations_form');
            
            const $addCartButton = $form.find('.add_to_cart_button:not(.out_of_stock_button)'),
                $noStockButton = $form.find('.out_of_stock_button');
            
            if(typeof val != 'undefined') {
                if(val.length) {
                    $addCartButton.attr('disabled', false);
                    const regex = new RegExp('(.*?)\_nostock');
                    const nostock = regex.test(val);
                    if(nostock) {
                        $addCartButton.hide();
                        $noStockButton.show();
                    }else {
                        $addCartButton.show();
                        $noStockButton.hide();
                    }
                } else {
                    $addCartButton.attr('disabled', true);
                    
                    if( $(this).hasClass('emptyStock') ) {
                        $addCartButton.hide();
                        $noStockButton.show();
                    }else{
                        $addCartButton.show();
                        $noStockButton.hide();
                    }
                }
                
            }else{

                $addCartButton.attr('disabled', true);
                
                if( $(this).hasClass('emptyStock') ) {
                    $addCartButton.hide();
                    $noStockButton.show();
                }else{
                    $addCartButton.show();
                    $noStockButton.hide();
                }
            }
            
        });

        $('.available-variations').trigger('change');
    }
    
    if($('.quantity').length) {

        $('.quantity').on('change', function() {
            
            const $field = $(this).find('input');
            
            let max = $field.attr('max'),
                val = $field.val();
            
         
            if(typeof max != 'undefined' && typeof val != 'undefined') {
                
                max = parseInt(max);
                val = parseInt(val);
                
                if(!isNaN(max) && !isNaN(val)) {
                   
                    if(val > max) {
                        $field.val(max);
                    }
                    
                }
                
            }
            
            
        });
        
    }
    

});

